var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"inline-block rounded-full animate-spin ml-1",class:_vm.customClass,style:({
            width: _vm.size === 'default' ? '1.5rem' : '1rem',
            height: _vm.size === 'default' ? '1.5rem' : '1rem',
            border: `2px solid ${_vm.color}`,
            borderTopColor: 'transparent',
        })})
}
var staticRenderFns = []

export { render, staticRenderFns }